<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/aldtek/ald_logo.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <router-link to="/">
            <img src="img/brand/aldtek/ald_logo.png" />
          </router-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <router-link
          slot="title"
          to="/"
          class="nav-link"
          data-toggle="dropdown"
          role="button"
          exact
        >
          <i class="ni ni-ui-04 d-lg-none"></i>
          <span class="nav-link-inner--text">Home</span>
        </router-link>
        <base-dropdown tag="li" class="nav-item">
          <router-link
            slot="title"
            to="/"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
            exact
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Template Examples</span>
          </router-link>
          <router-link to="/components" class="dropdown-item"
            >Components</router-link
          >
          <router-link to="/landing" class="dropdown-item">Landing</router-link>
          <router-link to="/profile" class="dropdown-item">Profile</router-link>
          <router-link to="/login" class="dropdown-item">Login</router-link>
          <router-link to="/register" class="dropdown-item"
            >Register</router-link
          >
        </base-dropdown>
        <base-dropdown tag="li" class="nav-item">
          <router-link
            slot="title"
            to="/"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Games</span>
          </router-link>
          <router-link to="/monster-slayer" class="dropdown-item"
            >Monster Slayer</router-link
          >
        </base-dropdown>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
